module.exports = ".forms-full-width {\r\n    width: 100%;\r\n}\r\n\r\n.form-field {\r\n    width: 33%;\r\n}\r\n\r\n.float-right {\r\n    float: right;\r\n}\r\n"